var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-pro-detail_titles"},[_c('p',{staticClass:"title",class:[
      {'title_isdetail': _vm.inDetail},
      {'bmfind_title': _vm.bmfind},
      {'smallCard_title': _vm.smallCard}
    ]},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"subtitle",class:[
        {'subtitle_isdetail': _vm.inDetail},
        {'smallCard_subtitle': _vm.smallCard}
  ]},[_vm._v(_vm._s(_vm.subtitle))]),_vm._v(" "),(_vm.mark && _vm.mark.length > 0)?_c('div',{staticClass:"tags",class:[
      {'tags_isdetail': _vm.inDetail},
      {'smallCard_tags': _vm.smallCard}
      ]},_vm._l((_vm.mark),function(item,index){return _c('t-tag',{key:index,attrs:{"txt":item.name,"redColor":item.flag === 1,"goldTag":item.flag === 1,"smallCard":_vm.smallCard}})})):_vm._e(),_vm._v(" "),(_vm.price)?_c('div',{staticStyle:{"text-align":"center"}},[_c('t-price',{attrs:{"price":_vm.price,"inDetail":_vm.inDetail,"smallCard":_vm.smallCard,"unit":_vm.unit}})],1):_vm._e(),_vm._v(" "),(_vm.id)?_c('div',{staticClass:"pro_id"},[_vm._v("产品编号："+_vm._s(_vm.id))]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3779190","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TProDetailTitles.vue
// module id = null
// module chunks = 